export default __webpack_public_path__ + "static/media/show_4 1.205d80a4.svg";